module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.6d219042.mp3";